/** Bannière globale : signale toute requête de données en échec (sinon une erreur
 * réseau est avalée et la page affiche un état vide trompeur). Réessaie tout. */
import { useQueryClient } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';
import { ErrorBanner } from './ui';

export function NetworkErrorBanner() {
  const qc = useQueryClient();
  const cache = qc.getQueryCache();

  // Requêtes ACTIVES en erreur (isActive : au moins un observateur monté). On
  // exclut les requêtes abandonnées non encore GC : sinon une erreur transitoire
  // sur une page quittée afficherait une bannière fantôme ailleurs (~5 min).
  const errorCount = useSyncExternalStore(
    (cb) => cache.subscribe(cb),
    () => cache.getAll().filter((q) => q.isActive() && q.state.status === 'error').length,
  );

  if (errorCount === 0) return null;
  return (
    <ErrorBanner
      message="Impossible de charger certaines données (connexion ?)."
      onRetry={() => qc.refetchQueries()}
    />
  );
}
